import { LOCALE } from '../util/format.js';
import { addDays, DAYS_IN_WEEK, startOfWeek, type CalendarView } from './calendar-rules.js';

/**
 * What the calendar header says it is showing.
 *
 * Here rather than in `util/format.ts` with the other date formatters: it is the
 * only one that takes a `CalendarView`, and a shared utility reaching into a
 * feature folder for a type is the wrong direction. Everything else in the
 * section imports *from* util; this keeps that one-way.
 *
 * The week case spells the month once where both ends share it ("17 – 23 Aug
 * 2026") and twice where they do not, because a reader crossing a month boundary
 * is exactly the reader who needs telling.
 */
export function formatCalendarPeriod(view: CalendarView, anchor: Date): string {
  if (view === 'month') {
    return anchor.toLocaleDateString(LOCALE, { month: 'long', year: 'numeric' });
  }

  if (view === 'day') {
    return anchor.toLocaleDateString(LOCALE, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  const first = startOfWeek(anchor);
  const last = addDays(first, DAYS_IN_WEEK - 1);
  const sameMonth = first.getMonth() === last.getMonth();
  const sameYear = first.getFullYear() === last.getFullYear();
  const head = sameMonth
    ? String(first.getDate())
    : first.toLocaleDateString(
        LOCALE,
        sameYear
          ? { day: 'numeric', month: 'short' }
          : { day: 'numeric', month: 'short', year: 'numeric' },
      );
  const tail = last.toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${head} – ${tail}`;
}
